export const GET_COUPON_LIST_START = 'GET_COUPON_LIST_START';
export const GET_COUPON_LIST_SUCCESS = 'GET_COUPON_LIST_SUCCESS';
export const GET_COUPON_LIST_FAILED = 'GET_COUPON_LIST_FAILED';

export const GENERATE_COUPON_FOR_EMAIL_START = 'GENERATE_COUPON_FOR_EMAIL_START';
export const GENERATE_COUPON_FOR_EMAIL_SUCCESS = 'GENERATE_COUPON_FOR_EMAIL_SUCCESS';
export const GENERATE_COUPON_FOR_EMAIL_FAILED = 'GENERATE_COUPON_FOR_EMAIL_FAILED';

export const GENERATE_COUPON_RULE_START = 'GENERATE_COUPON_RULE_START';
export const GENERATE_COUPON_RULE_SUCCESS = 'GENERATE_COUPON_RULE_SUCCESS';
export const GENERATE_COUPON_RULE_FAILED = 'GENERATE_COUPON_RULE_FAILED';

export const UPDATE_COUPON_RULE_COMBINED_START = 'UPDATE_COUPON_RULE_COMBINED_START';
export const UPDATE_COUPON_RULE_COMBINED_SUCCESS = 'UPDATE_COUPON_RULE_COMBINED_SUCCESS';
export const UPDATE_COUPON_RULE_COMBINED_FAILED = 'UPDATE_COUPON_RULE_COMBINED_FAILED';

export const CREATE_COUPON_RULE_COMBINED_START = 'CREATE_COUPON_RULE_COMBINED_START';
export const CREATE_COUPON_RULE_COMBINED_SUCCESS = 'CREATE_COUPON_RULE_COMBINED_SUCCESS';
export const CREATE_COUPON_RULE_COMBINED_FAILED = 'CREATE_COUPON_RULE_COMBINED_FAILED';

export const GET_COUPON_RULES_START = 'GET_COUPON_RULES_START';
export const GET_COUPON_RULES_SUCCESS = 'GET_COUPON_RULES_SUCCESS';
export const GET_COUPON_RULES_FAILED = 'GET_COUPON_RULES_FAILED';

export const GET_COUPON_CODE_START = 'GET_COUPON_CODE_START';
export const GET_COUPON_CODE_SUCCESS = 'GET_COUPON_CODE_SUCCESS';
export const GET_COUPON_CODE_FAILED = 'GET_COUPON_CODE_FAILED';

export const DELETE_COUPON_RULE_START = 'DELETE_COUPON_RULE_START';
export const DELETE_COUPON_RULE_SUCCESS = 'DELETE_COUPON_RULE_SUCCESS';
export const DELETE_COUPON_RULE_FAILED = 'DELETE_COUPON_RULE_FAILED';

export const SET_EDITABLE_RULE = 'SET_EDITABLE_RULE';


export const getCouponListStart = () => ({
  type: GET_COUPON_LIST_START
});

export const getCouponListSuccess = (data) => ({
  type: GET_COUPON_LIST_SUCCESS,
  data
});

export const getCouponListFailed = (error) => ({
  type: GET_COUPON_LIST_FAILED,
  error
});

export const generateCouponForEmailStart = () => ({
  type: GENERATE_COUPON_FOR_EMAIL_START
});

export const generateCouponForEmailSuccess = (data) => ({
  type: GENERATE_COUPON_FOR_EMAIL_SUCCESS,
  data
});

export const generateCouponForEmailFailed = (error) => ({
  type: GENERATE_COUPON_FOR_EMAIL_FAILED,
  error
});

export const generateCouponRuleStart = () => ({
  type: GENERATE_COUPON_RULE_START
});

export const generateCouponRuleSuccess = (data) => ({
  type: GENERATE_COUPON_RULE_SUCCESS,
  data
});

export const generateCouponRuleFailed = (error) => ({
  type: GENERATE_COUPON_RULE_FAILED,
  error
});

export const updateCouponRuleCombinedStart = () => ({
  type: UPDATE_COUPON_RULE_COMBINED_START
});

export const updateCouponRuleCombinedSuccess = (updatedCouponRule) => ({
  type: UPDATE_COUPON_RULE_COMBINED_SUCCESS,
  updatedCouponRule
});

export const updateCouponRuleCombinedFailed = (error) => ({
  type: UPDATE_COUPON_RULE_COMBINED_FAILED,
  error
});

export const setEditableRule = (rule) => ({
  type: SET_EDITABLE_RULE,
  rule
});

export const createCouponRuleCombinedStart = () => ({
  type: CREATE_COUPON_RULE_COMBINED_START
});

export const createCouponRuleCombinedSuccess = () => ({
  type: CREATE_COUPON_RULE_COMBINED_SUCCESS
});

export const createCouponRuleCombinedFailed = (error) => ({
  type: CREATE_COUPON_RULE_COMBINED_FAILED,
  error
});

export const getCouponRulesStart = () => ({
  type: GET_COUPON_RULES_START
});

export const getCouponRulesSuccess = (rulesData, couponData) => ({
  type: GET_COUPON_RULES_SUCCESS,
  rulesData,
  couponData
});

export const getCouponRulesFailed = (error) => ({
  type: GET_COUPON_RULES_FAILED,
  error
});

export const getCouponCodeStart = () => ({
  type: GET_COUPON_CODE_START
});

export const getCouponCodeSuccess = (data, rule_id) => ({
  type: GET_COUPON_CODE_SUCCESS,
  data,
  rule_id
});

export const getCouponCodeFailed = (error) => ({
  type: GET_COUPON_CODE_FAILED,
  error
});

export const deleteCouponRuleStart = () => ({
  type: DELETE_COUPON_RULE_START
});

export const deleteCouponRuleSuccess = (id) => ({
  type: DELETE_COUPON_RULE_SUCCESS,
  id
});

export const deleteCouponRuleFailed = (error) => ({
  type: DELETE_COUPON_RULE_FAILED,
  error
});
